import { ButtonSizes, ButtonVariant } from 'tailwind/components/Button/Button.types';

export const contentWrapperClasses = 'flex gap-x-2 items-center';

export const variantClasses: Record<ButtonVariant, string> = {
  filled: 'bg-button-primary text-button-reversed rounded-full border-none',
  outlined: 'bg-button-transparent text-button-primary border border-solid border-button-primary rounded-full',
  text: 'bg-button-transparent text-link-default underline underline-offset-4 border-none'
};

export const visitedClasses: Record<ButtonVariant, string> = {
  filled: 'visited:bg-button-visited',
  outlined: 'visited:border-button-visited visited:text-button-visited',
  text: 'visited:text-link-visited'
};

export const hoverClasses: Record<ButtonVariant, string> = {
  filled: 'hover:bg-button-hover',
  outlined: 'hover:border-button-hover hover:text-button-hover',
  text: 'hover:text-link-hover'
};

export const disabledClasses: Record<ButtonVariant, string> = {
  filled: 'disabled:bg-button-disabled-subtle disabled:text-button-reversed disabled:cursor-not-allowed',
  outlined: 'disabled:text-button-disabled-minimal disabled:border-button-disabled disabled:cursor-not-allowed',
  text: 'disabled:text-link-disabled disabled:cursor-not-allowed'
};

export const sizeClasses: Record<ButtonVariant, Record<ButtonSizes, string>> = {
  filled: {
    small: 'text-sm px-4 py-2',
    base: 'text-base px-6 py-2'
  },
  outlined: {
    small: 'text-sm px-4 py-2',
    base: 'text-base px-6 py-2'
  },
  text: {
    small: 'text-sm p-0',
    base: 'text-base p-0'
  }
};

export const commonClasses = 'w-fit items-center box-border cursor-pointer inline-flex justify-center whitespace-nowrap focus:outline';
